/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DiscountData } from './DiscountData';
import {
    DiscountDataFromJSON,
    DiscountDataFromJSONTyped,
    DiscountDataToJSON,
    DiscountDataToJSONTyped,
} from './DiscountData';

/**
 * 
 * @export
 * @interface DiscountPerformance
 */
export interface DiscountPerformance {
    /**
     * 
     * @type {Array<DiscountData>}
     * @memberof DiscountPerformance
     */
    discounts?: Array<DiscountData>;
}

/**
 * Check if a given object implements the DiscountPerformance interface.
 */
export function instanceOfDiscountPerformance(value: object): value is DiscountPerformance {
    return true;
}

export function DiscountPerformanceFromJSON(json: any): DiscountPerformance {
    return DiscountPerformanceFromJSONTyped(json, false);
}

export function DiscountPerformanceFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscountPerformance {
    if (json == null) {
        return json;
    }
    return {
        
        'discounts': json['discounts'] == null ? undefined : ((json['discounts'] as Array<any>).map(DiscountDataFromJSON)),
    };
}

export function DiscountPerformanceToJSON(json: any): DiscountPerformance {
    return DiscountPerformanceToJSONTyped(json, false);
}

export function DiscountPerformanceToJSONTyped(value?: DiscountPerformance | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'discounts': value['discounts'] == null ? undefined : ((value['discounts'] as Array<any>).map(DiscountDataToJSON)),
    };
}

